<p-dialog
  [header]="itemName || 'Linked CAD Objects'"
  [modal]="true"
  [(visible)]="dialogVisible"
  [style]="{ width: '85vw', height: '85vh' }"
  [appendTo]="'body'"
  [dismissableMask]="true"
  [closable]="true"
  (onShow)="onDialogShow()"
  (onHide)="onDialogHide()"
>
  @if (!cadObjectIds.length) {
    <div class="flex items-center gap-2 text-muted-color">
      <i class="pi pi-info-circle"></i>
      <span>No linked CAD objects found for this item.</span>
    </div>
  } @else {
    <div class="flex gap-4" style="height: calc(85vh - 120px)">
      <div class="flex flex-col w-[40%] gap-4" style="min-height: 0">
        <div class="h-1/2">
          <app-cad-viewer
            [cadObjects]="loadedCadObjects"
            [visibleCadObjectIds]="visibleCadObjectIds"
            [externallyHoveredCadObjectId]="hoveredCadObjectId"
            (hoveredCadObjectIdChange)="hoveredCadObjectId = $event"
          ></app-cad-viewer>
        </div>

        <p-divider />

        <div class="h-1/2 overflow-y-auto">
          <app-cad-object-tree
            class="block h-full"
            [cadObjects]="loadedCadObjects"
            [selectable]="true"
            [selectedCadObjectId]="selectedCadObject?.id ?? null"
            (selectedCadObjectChange)="onSelectedCadObjectChange($event)"
            [hoveredCadObjectId]="hoveredCadObjectId"
            (hoveredCadObjectIdChange)="hoveredCadObjectId = $event"
            (visibleCadObjectIdsChange)="visibleCadObjectIds = $event"
          ></app-cad-object-tree>
        </div>
      </div>

      <p-divider layout="vertical" />

      <div class="w-[60%] overflow-y-auto" style="min-height: 0">
        @if (selectedCadObject; as cadObject) {
          <h4 class="text-lg font-semibold mb-4">{{ cadObject.name }}</h4>
          <app-cad-properties [cadObject]="cadObject" />
        } @else {
          <div class="text-muted-color">No CAD object loaded</div>
        }
      </div>
    </div>
  }
</p-dialog>
